import React from 'react';

import TimeOffPanel from 'components/sidebar/timeOff/TimeOffPanel.component';
import useTip from 'hooks/useTip.hook';

import CN from './TimeOffPage.module.scss';

const TimeOffPage = () => {
  const { val: isSidebarRendered, tip: toggleSidebar } = useTip(true);
  const { val: isMainPanelRendered, tip: toggleMainPanel } = useTip(false);

  return (
    <div data-bem="TimeOffPage" className={CN.component}>
      <div className={CN.nav}>
        <button data-bem="TimeOffPage__left" data-tag="left" onClick={toggleMainPanel}>
          Toggle MainPanel
        </button>
        <div data-bem="TimeOffPage__top" data-tag="top">
          This would be what you see in the navigation bar.
        </div>
        <div data-bem="TimeOffPage__bottom" data-tag="bottom">
          For testing/development purposes.
        </div>
        <button data-bem="TimeOffPage__right" data-tag="right" onClick={toggleSidebar}>
          Toggle Sidebar
        </button>
      </div>

      {isSidebarRendered && <TimeOffPanel />}
      {isMainPanelRendered && <TimeOffPanel />}
    </div>
  );
};

export default TimeOffPage;
